import React from 'react';
import Hero from './hero.jsx';
import { useReveal, Nav, Marquee, About, Skills } from './sections.jsx';
import { Projects, Experience, Awards, Contact, Footer } from './projects.jsx';
import { useTweaks, TweaksPanel, TweakSection, TweakSelect } from '../tweaks-panel.jsx';

const FONT_OPTIONS = {
  'Space Grotesk':     "'Space Grotesk', system-ui, sans-serif",
  'Plus Jakarta Sans': "'Plus Jakarta Sans', system-ui, sans-serif",
  'Inter':             "'Inter', system-ui, sans-serif",
  'Geist':             "'Geist', system-ui, sans-serif",
  'Manrope':           "'Manrope', system-ui, sans-serif",
};

const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "font": "Space Grotesk"
}/*EDITMODE-END*/;

function App() {
  useReveal();
  const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);

  React.useEffect(() => {
    const stack = FONT_OPTIONS[t.font] || FONT_OPTIONS['Space Grotesk'];
    document.documentElement.style.setProperty('--ui-font', stack);
  }, [t.font]);

  return (
    <React.Fragment>
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <Skills />
      <Projects />
      <Experience />
      <Awards />
      <Contact />
      <Footer />

      <TweaksPanel title="Tweaks">
        <TweakSection label="Typography" />
        <TweakSelect
          label="Display font"
          value={t.font}
          options={Object.keys(FONT_OPTIONS)}
          onChange={(v) => setTweak('font', v)}
        />
        <div style={{ fontSize: 10.5, color: 'rgba(41,38,27,.55)', padding: '2px 0 4px', lineHeight: 1.45 }}>
          Switches the display + body font live across the page.
        </div>
      </TweaksPanel>
    </React.Fragment>
  );
}

export default App;
